import styled from '@emotion/styled/macro';
import { H2 } from '../../../common/Headings/Headings.styles';
import rem from '../../../utils/rem/rem';

export const AddOptionPage = styled.div`
  padding: 0 32px 32px 32px;
  height: 95%;
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: ${rem(32)};
`;

export const StyledH2 = styled(H2)`
  margin-bottom: ${rem(16)};
`;

export const StyledP = styled.p`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: ${rem(14)};
  margin-bottom: ${rem(24)};
`;

export const Buttons = styled.div`
  padding-top: ${rem(32)};
  display: flex;
  justify-content: space-between;
`;
